export function logError(location: string, ...params: unknown[]) {
  console.error(location, ...params);
}
